import { Injectable } from '@angular/core';
import { HttpLogado } from '../HttpLogado';
import { environment } from '../../environments/environment';

export interface KPIReturn {
  error: false;
  connection: {
    message: string,
    status: 'Connected' | 'Disconnected' | 'Error',
    details: any
  };
  history: {
    errors: number,
    inProgress: number,
    success: number
  };
  plan: {
    deliveriesQuantity: number,
    name: string,
    planExpiration: Date,
  };
}

export interface HistoryReturn {
  idSchedule: number;
  idContact: number;
  idReport: number;
  idDelivery: number;
  idHistory: string;
  message: string;
  name: string;
  historyType: 'Sending' | 'Complete' | 'Error';
  startDate: Date;
  endDate: Date | null;
  lastOpen: Date | null;
  countOpen: string;
}

@Injectable({
  providedIn: 'root'
})
export class KPIService {

  constructor(
    private http: HttpLogado
  ) { }

  async getKPIs(): Promise<KPIReturn> {
    try {
      const data: any = await this.http.get(`${environment.baseUrl}/kpi`).toPromise();
      if (!data) {
        throw new Error('KPI retrieval error: Server returned empty or null object of type ' + (typeof data));
      }
      if (data && !data.plan && typeof data.message === 'string') {
        throw new Error('KPI retrieval error: Server returned error message:' + data.message);
      }
      if (!data || !data.plan || !data.plan.planExpiration) {
        throw new Error('KPI retrieval error: Server returned incorrect or unhandled object format');
      }
      data.plan.planExpiration = new Date(data.plan.planExpiration);
      data.error = false;
      return data as KPIReturn;
    } catch(err) {
      console.log(err);
      throw err;
    }
  }

  async getHistory(): Promise<HistoryReturn[]> {
    try {
      const data: any = await this.http.get(`${environment.baseUrl}/history`).toPromise();
      if (!data || !(data instanceof Array)) {
        throw new Error('Server returned incorrect, empty or unhandled object format');
      }
      for (const history of data) {
        history.startDate = new Date(history.startDate);
        history.endDate = history.endDate === null ? null : new Date(history.endDate);
        history.lastOpen = history.lastOpen === null ? null : new Date(history.lastOpen);
        history.idSchedule = parseInt(history.idSchedule, 10);
        history.idDelivery = parseInt(history.idDelivery, 10);
        history.idContact = parseInt(history.idContact, 10);
        history.idReport = parseInt(history.idReport, 10);
        switch (history.historyType) {
          case 'S': history.historyType = 'Sending'; break;
          case 'C': history.historyType = 'Complete'; break;
          default: history.historyType = 'Error';
        }
      }
      return data;
    } catch(err) {
      console.log(err);
      throw err;
    }
  }
}
